import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import getQuotingEnginePrice from '@shared/utils/frontend/pricing/get-quoting-engine-price';
import { useSession } from '@/contexts/LitSessionProvider';
export function useEnginePrice() {
  var _a;
  const {
    PKP
  } = useSession();
  const [params, setParams] = useState({
    cloudWallet: null,
    solanaAddress: (PKP === null || PKP === void 0 ? void 0 : PKP.solanaAddress) || null,
    tokensIn: [],
    tokensOut: [],
    fromSlippage: 0,
    toSlippage: 0,
    fromGasMultiplier: 1,
    toGasMultiplier: 1,
    permitBatchDetails: [],
    permitSignatures: [],
    publicKeys: {
      payer: '',
      feePayer: ''
    },
    refreshToken: '',
    priorityFee: 0
  });
  const {
    cloudWallet,
    solanaAddress,
    tokensIn,
    tokensOut,
    fromSlippage,
    permitBatchDetails,
    permitSignatures,
    priorityFee
  } = params;
  const handleSetParams = (key, value) => {
    setParams(prev => {
      return Object.assign(Object.assign({}, prev), {
        [key]: value
      });
    });
  };
  const enabled = () => {
    if (!cloudWallet) {
      const enabledError = 'No cloud wallet';
      return {
        enabled: false,
        error: enabledError
      };
    }
    if (!tokensIn.length) {
      const enabledError = 'No tokens in';
      return {
        enabled: false,
        error: enabledError
      };
    }
    if (tokensIn.some(token => !token.amount || token.amount === '0')) {
      const enabledError = 'No token amount';
      return {
        enabled: false,
        error: enabledError
      };
    }
    if (!tokensOut.length) {
      const enabledError = 'No tokens out';
      return {
        enabled: false,
        error: enabledError
      };
    }
    if (!fromSlippage) {
      const enabledError = 'No from slippage';
      return {
        enabled: false,
        error: enabledError
      };
    }
    if (!priorityFee) {
      const enabledError = 'No priority fee';
      return {
        enabled: false,
        error: enabledError
      };
    }
    return {
      enabled: true,
      error: ''
    };
  };
  const query = useQuery({
    queryKey: ['enginePrice', params],
    queryFn: async () => {
      const data = await getQuotingEnginePrice({
        cloudWallet,
        solanaAddress,
        tokensIn,
        tokensOut,
        fromSlippage,
        permitBatchDetails,
        permitSignatures,
        priorityFee,
        baseUrl: '/api/wrapper?target=',
        PKP: Object.assign({}, PKP)
      });
      return data;
    },
    enabled: (_a = enabled()) === null || _a === void 0 ? void 0 : _a.enabled
  });
  return Object.assign(Object.assign({}, query), {
    setParams,
    handleSetParams,
    params
  });
}